// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__j24MF","lds-ring":"Spinner_lds-ring__SOAMb"};